import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MyAccountV2Pagination, MyAccountV2UsersApiParams, UserProfile } from '../models';
import { MyAccountV2Client } from './my-account-v2.client';

@Injectable({
  providedIn: 'root',
})
export class UsersV2Api {
  private readonly basePath = '/users';

  constructor(private _http: MyAccountV2Client) {}

  userInfo(): Observable<UserProfile> {
    return this._http.get(`${this.basePath}/info`);
  }

  fetchByQuery(params: Partial<MyAccountV2UsersApiParams>): Observable<MyAccountV2Pagination<UserProfile>> {
    const defaultParams = { limit: 30, sortBy: 'createdDate:DESC' };
    return this._http.get(this.basePath, { ...defaultParams, ...params });
  }
}
